import { apiClient } from './client'

export interface FamilyEvent {
  id: string; title: string; notes: string; location: string; time_zone: string; all_day: boolean
  start_at: string | null; end_at: string | null; start_date: string | null; end_date: string | null
  source: string; source_url: string; version: number; cancelled: boolean; can_edit: boolean
  responses: { user_id: string; name: string; response: string }[]
  invitations: { email: string; status: string; error: string }[]
}
export interface CalendarAgenda { events: FamilyEvent[]; can_create: boolean; email_available: boolean; family_email: string }
const root = (family: string) => `/families/${family}/calendar`
export const calendarApi = {
  list: (family: string) => apiClient.get<CalendarAgenda>(`${root(family)}/events`),
  save: (family: string, data: unknown, id?: string) => id ? apiClient.put<FamilyEvent>(`${root(family)}/events/${id}`, data) : apiClient.post<FamilyEvent>(`${root(family)}/events`, data),
  action: (family: string, id: string, action: string, data: unknown = {}) => apiClient.post<FamilyEvent>(`${root(family)}/events/${id}/${action}`, data),
  ics: (family: string, id: string) => apiClient.getBlob(`${root(family)}/events/${id}/ics`),

}

export function eventTime(event: FamilyEvent, zone = Intl.DateTimeFormat().resolvedOptions().timeZone): string {
  if (event.all_day) {
    const last = new Date(`${event.end_date}T12:00:00Z`)
    last.setUTCDate(last.getUTCDate() - 1)
    const lastDate = last.toISOString().slice(0, 10)
    return `${event.start_date}${lastDate !== event.start_date ? ` – ${lastDate}` : ''} · All day`
  }
  const format = (value: string, timeZone: string) => new Intl.DateTimeFormat(undefined, { dateStyle: 'medium', timeStyle: 'short', timeZone }).format(new Date(value))
  const local = `${format(event.start_at!, zone)} – ${format(event.end_at!, zone)}`
  return zone === event.time_zone ? `${local} (${zone})` : `${local} (${zone}) · Appointment: ${format(event.start_at!, event.time_zone)} (${event.time_zone})`
}

export function googleCalendarUrl(event: FamilyEvent): string {
  const stamp = (s: string) => new Date(s).toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '')
  const dates = event.all_day ? `${event.start_date!.replace(/-/g, '')}/${event.end_date!.replace(/-/g, '')}` : `${stamp(event.start_at!)}/${stamp(event.end_at!)}`
  return 'https://calendar.google.com/calendar/render?' + new URLSearchParams({ action: 'TEMPLATE', text: event.title, dates, details: event.notes, location: event.location, ctz: event.time_zone })
}

export function shiftCalendarDay(value: string, days: number): string {
  const date = new Date(`${value}T12:00:00Z`)
  date.setUTCDate(date.getUTCDate() + days)
  return date.toISOString().slice(0, 10)
}

/** Outlook opens its own compose screen; FamSteady never connects to the account. */
export function outlookCalendarUrl(event: FamilyEvent, workAccount = false): string {
  const host = workAccount ? 'outlook.office.com' : 'outlook.live.com'
  const start = event.all_day ? `${event.start_date}T00:00:00` : new Date(event.start_at!).toISOString()
  const end = event.all_day ? `${event.end_date}T00:00:00` : new Date(event.end_at!).toISOString()
  return `https://${host}/calendar/0/deeplink/compose?` + new URLSearchParams({ path: '/calendar/action/compose', rru: 'addevent', subject: event.title, body: event.notes, location: event.location, startdt: start, enddt: end, allday: String(event.all_day) })
}
